import React, { Component } from "react";
import { setSystemUnavailable } from "../../../actions/networkStateActions";
import Information from "../Information";
import Content from "../../../content/Content";
import Store from "../../../content/Store";
import { connect } from "react-redux";
import Logout from "../../logout/Logout";
import styles from "../../../assets/css/modules/information/errors/sharedErrorContent/error-content-links.css";

export const mapDispatchToProps = (dispatch) => {
  return {
    setSystemUnavailable: (value) => dispatch(setSystemUnavailable(value))
  };
};

export const mapStateToSystemUnavailable = (state) => {
  return {
    systemUnavailable:
      state &&
      state.networkStateReducer &&
      state.networkStateReducer.systemUnavailable
  };
};

export class SystemUnavailable extends Component {
  componentDidMount() {
    if (this.props.systemUnavailable) {
      this.props.setSystemUnavailable(false);
    }
  }

  render() {
    return (
      <Information headerText={Store.ErrorPages.SystemUnavailable.HeaderText}>
        <Content name={Store.ErrorPages.SystemUnavailable.Message} />
        <span className={styles.sharedErrorContent}>
          <Content name={Store.ErrorPages.SystemUnavailable.Note} />{" "}
          <Logout inline />
        </span>
      </Information>
    );
  }
}

export default connect(
  mapStateToSystemUnavailable,
  mapDispatchToProps
)(SystemUnavailable);
